import React, { useState } from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { useAllowedClinics } from '@/v2/hooks/useAllowedClinics'
import { getHostname } from '@/v2/utils/hostname'
import { headers } from '@/v2/constants/requests'
import { SwitcherButton, ClinicName, ArrowWrapper, LogoBox } from './styles'

const getInitials = (name = '') => {
  const words = name.trim().split(/\s+/)
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
  return name.slice(0, 2).toUpperCase()
}

const buildClinicUrl = subdomain => {
  const { domain, type } = getHostname()
  const port = window.location.port ? `:${window.location.port}` : ''
  return `${window.location.protocol}//${subdomain}.${domain}.${type}${port}${window.location.pathname}`
}

const switchClinic = async subdomain => {
  await fetch(`${window.location.origin}/v2/rest/sessions/switch`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ session: { subdomain } }),
  })

  window.location.assign(buildClinicUrl(subdomain))
}

const ClinicSwitcher = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { clinics } = useAllowedClinics()
  const { subdomain: currentSubdomain } = getHostname()

  const currentClinic = clinics.find(c => c.subdomain === currentSubdomain)
  const clinicName = currentClinic?.name || ''
  const hasMultipleClinics = clinics.length > 1

  const handleOpen = event => {
    if (hasMultipleClinics) setAnchorEl(event.currentTarget)
  }

  const handleClose = () => setAnchorEl(null)

  const handleSelect = clinic => {
    handleClose()
    if (clinic.subdomain !== currentSubdomain) switchClinic(clinic.subdomain)
  }

  return (
    <>
      <SwitcherButton
        onClick={handleOpen}
        style={{ cursor: hasMultipleClinics ? 'pointer' : 'default' }}
      >
        <LogoBox>{getInitials(clinicName)}</LogoBox>
        <ClinicName>{clinicName}</ClinicName>
        {hasMultipleClinics && (
          <ArrowWrapper>
            <KeyboardArrowDownIcon sx={{ color: '#7D7D7D', fontSize: 20 }} />
          </ArrowWrapper>
        )}
      </SwitcherButton>

      {hasMultipleClinics && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          autoFocus={false}
          slotProps={{
            paper: {
              style: { maxHeight: 48 * 6, minWidth: 200 },
            },
          }}
        >
          {clinics.map(clinic => (
            <MenuItem key={clinic.id} onClick={() => handleSelect(clinic)}>
              <ListItemText
                primary={clinic.name}
                primaryTypographyProps={{
                  fontWeight: clinic.subdomain === currentSubdomain ? 700 : 400,
                  fontSize: '14px',
                }}
              />
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  )
}

export default ClinicSwitcher
